import { toast } from "react-toastify";
import { ModuleType } from "../constants/ModuleType";
import { SCORM_API_URL, LW_COURSE_API_URL } from "../constants/api.constants";
import { TOAST_CONFIG } from "./toastConfig";

export function getWinOptions() {
  var winOptions = "toolbar=no,status=no,location=no,menubar=no,scrollbars=yes";
  winOptions = winOptions + ",width=" + window.screen.availWidth.toString();
  winOptions = winOptions + ",height=" + window.screen.availHeight.toString();
  return winOptions;
}

export function getQapiWinOptions() {
  return `fullscreen=yes,width=${window.screen.width},height=${window.screen.height}`;
}

// Safari (iOS/iPadOS) blocks window.open once a network call has completed, so
// the window must be opened in the click and navigated when the server answers.
export function openWindowBeforeRequest(intl, winOptions) {
  const win = window.open("", "", winOptions);
  if (!win) {
    toast.warn(intl.formatMessage({ id: "PopupBlocked" }), TOAST_CONFIG);
  }
  return win;
}

export function isGy25TestModule(module) {
  return module.isGy25 && !module.isFactModule && !module.isFinalExam;
}

// A Gy25 fact module and its coupled test module are shown as one row in the
// result views. Returns the fact module's coupled test module, or null.
export function findCoupledTestModule(module, modules) {
  const isGy25FactModule =
    module.isGy25 && module.isFactModule && !module.isFinalExam;

  if (!isGy25FactModule || module.moduleCoupleId == null) {
    return null;
  }

  return (
    modules.find(
      (other) =>
        other.moduleCoupleId === module.moduleCoupleId &&
        isGy25TestModule(other),
    ) ?? null
  );
}

// Attempts shown on a module row in the result views: the coupled test
// module's when it has any, otherwise the module's own. Empty when none.
export function getNbrOfAttemptsToShow(moduleAttempts, coupledTestAttempts) {
  if (coupledTestAttempts > 0) return coupledTestAttempts;

  return moduleAttempts > 0 ? moduleAttempts : null;
}

// Scores are stored with up to 4 decimals. Round to 2 decimals so that every
// result view displays the same value for the same student and module.
export function roundScore(score) {
  return Math.round(score * 100) / 100;
}

export function composeUrl(
  userId,
  courseId,
  moduleId,
  moduleType,
  studentResultId,
  moduleUrl,
  studentName,
  numberOfRuns,
  isGy25FinalExam,
) {
  var url;
  var email = localStorage.getItem("email");
  var numOfRunsIncramented = (numberOfRuns += 1);
  if (moduleType === ModuleType.LEARNWARE || moduleType === "LearnWare") {
    url =
      `${LW_COURSE_API_URL}/Home/StartLwCourse?` +
      "email=" +
      encodeURIComponent(email) +
      "&userId=" +
      userId +
      "&courseId=" +
      courseId +
      "&moduleId=" +
      moduleId;
  } else {
    url =
      `${SCORM_API_URL}/BootstrapDialog?` +
      "userId=" +
      userId +
      "&studentResultId=" +
      studentResultId +
      "&courseId=" +
      courseId +
      "&moduleId=" +
      moduleId +
      "&url=" +
      moduleUrl +
      "&name=" +
      studentName +
      "&isGy25FinalExam=" +
      isGy25FinalExam +
      "&run=" +
      numOfRunsIncramented;
  }
  return `${url}&tick=${Date.now()}`;
}
